"use client"

import type { AnchorHTMLAttributes } from "react"
import { BOOK_DEMO_URL } from "../constants"

/**
 * Calendly link that keeps the "Book Demo CTA Clicked" event the old homepage sent. The tracker (and the zod
 * catalog it validates against) loads on click, not with every public page; the link opens a new tab, so this
 * page is still there to send the event.
 */
export function DemoLink({
  location,
  testId,
  ...props
}: { location: string; testId?: string } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href">) {
  return (
    <a
      {...props}
      href={BOOK_DEMO_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId ?? `home-book-demo-${location}`}
      onClick={() => void import("@/lib/analytics/track").then(({ track }) => track("Book Demo CTA Clicked", { location, href: BOOK_DEMO_URL }))}
    >
      {props.children}
      <span className="vh"> (opens in a new tab)</span>
    </a>
  )
}
